const IconLabelLabelCarCeroEmisiones = 'coches/icons/eco-label-0.svg'
const IconLabelCarB = 'coches/icons/eco-label-b.svg'
const IconLabelCarC = 'coches/icons/eco-label-c.svg'
const IconLabelCarEco = 'coches/icons/eco-label-eco.svg'

export const ICONS_BY_ENVIRONMENTAL_LABEL = {
  0: IconLabelLabelCarCeroEmisiones,
  B: IconLabelCarB,
  C: IconLabelCarC,
  ECO: IconLabelCarEco
}
